module.exports = __webpack_public_path__ + "img/hw-b2.795f8a9d.png";